// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label[data-v-4d82bc5d]{align-items:center;border:.005rem solid;border-radius:.02rem;display:flex;font-weight:700;padding:0 .04rem;width:-moz-fit-content;width:fit-content}.region-exclusive[data-v-4d82bc5d]{border-color:var(--secondary-700);color:var(--secondary-700)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
